import { isAfter, parseISO } from "date-fns"
import type { Produto } from "../../types/produto.props"
import { zordDbDatetimeToStr } from "@/utils/zordDbDatetimeToStr"
import { Counter } from "./Counter"
import { TipoPagamento } from "../../data/tipoPagamento"

interface OfertaComprarCountdownProps {
    produto: Produto
    precoPrincipal: number
    escondePrecoFuturo: boolean
    etapaOferta: number
    ofertaEstoqueDisponivel: boolean
    vitrineButtonAddToCart: string
}

export function OfertaComprarCountdown({
    produto,
    precoPrincipal,
    escondePrecoFuturo,
    etapaOferta,
    ofertaEstoqueDisponivel,
    vitrineButtonAddToCart
}: OfertaComprarCountdownProps) {
    const dataAtual = new Date()
    const dataInicio = produto.data_inicio ? parseISO(produto.data_inicio) : null
    const dataFim = produto.data_fim ? parseISO(produto.data_fim) : null

    let percentualOff = 0
    
    if (produto.valor_de > 0) {
        if (precoPrincipal === TipoPagamento.BOLETO) {
            percentualOff = 100 - (produto.valor_boleto / produto.valor_de) * 100
        } else {
            percentualOff = 100 - (produto.valor / produto.valor_de) * 100
        }
    }
    return (
        <div className="oferta-comprar-countdown">
            <div className="desconto-tempo-restante">
                <div className="desconto-oferta">
                    {percentualOff > 0 && (!escondePrecoFuturo || etapaOferta !== 1) && (
                        <div className={`desconto-ctn${!produto.data_fim && !produto.data_inicio ? ' maior' : ''}`}>
                            <div className="icon-fire"></div>
                            <div className="desconto">{Math.round(percentualOff)}% off</div>
                        </div>
                    )}

                    {(dataInicio && isAfter(dataInicio, dataAtual)) ? (
                        <div className={`oferta-countdown${percentualOff <= 0 || escondePrecoFuturo ? ' maior' : ''}`}>
                            <div
                                data-ini={zordDbDatetimeToStr(produto.data_inicio)}
                                data-refresh="true"
                                data-diff-days="true"
                            >
                                <div className="text-contador">Inicia em</div>
                                <Counter dataFim={produto.data_inicio} showDaysIfPositive={false} />
                            </div>
                        </div>
                    ) : (dataFim && ofertaEstoqueDisponivel) ? (
                        <div className={`oferta-countdown${percentualOff <= 0 ? ' maior' : ''}`}>
                            <div data-fim={zordDbDatetimeToStr(produto.data_fim)} data-diff-days="true">
                                <div className="icon-cont"></div>
                                <div className="text-contador">Acaba em</div>
                                <Counter dataFim={produto.data_fim} />
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="comprar-ctn">
                    {etapaOferta === 2 ? (
                        <div className="button button-full button-buy">{vitrineButtonAddToCart}</div>
                    ) : etapaOferta === 1 ? (
                        <div className="button button-full button-warning">Aguarde</div>
                    ) : (
                        <div className="button button-full button-light">Esgotado</div>
                    )}
                </div>
            </div>
        </div>
    )
}